import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ScrollText } from "lucide-react";
import { EmptyState, PageLoading, PageHeader, fmtDateTime } from "@/components/shared";
import api from "@/lib/api";

export default function AuditLogs() {
  const { t } = useTranslation();
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setLogs(r.data.logs)); }, []);
  if (logs === null) return <PageLoading />;
  const LABELS = {
    "company.granted_unlimited": t("adm.actGrantUnlimited"),
    "subscription.trial_extended": t("adm.actTrialExtended"),
    "TAG_SUSPENDED": t("adm.actTagSuspended"),
    "TAG_REACTIVATED": t("adm.actTagReactivated"),
    "company.deleted": t("adm.actCompanyDeleted"),
  };
  return (
    <div data-testid="admin-audit">
      <PageHeader title={t("adm.auTitle")} subtitle={t("adm.auSubtitle")} />
      {logs.length === 0 ? <EmptyState icon={ScrollText} title={t("adm.auEmpty")} /> : (
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
          <table className="w-full text-sm">
            <thead className="border-b border-slate-200 bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-400">
              <tr><th className="px-4 py-3">{t("adm.auActor")}</th><th className="px-4 py-3">{t("adm.auAction")}</th><th className="px-4 py-3">{t("adm.auResource")}</th><th className="px-4 py-3">{t("adm.auDetails")}</th><th className="px-4 py-3">{t("adm.auTime")}</th></tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-slate-50 hover:bg-slate-50">
                  <td className="px-4 py-3 text-slate-600">{l.actor_name || l.actor_email || "system"}{l.actor_name && l.actor_email && <div className="text-xs text-slate-400">{l.actor_email}</div>}</td>
                  <td className="px-4 py-3">{LABELS[l.action] ? <><div className="font-medium text-navy">{LABELS[l.action]}</div><div className="font-mono text-[10px] text-slate-400">{l.action}</div></> : <span className="font-mono text-xs text-navy">{l.action}</span>}</td>
                  <td className="px-4 py-3 text-slate-600">{l.resource_type}{l.employee_name ? ` · ${l.employee_name}` : ""}</td>
                  <td className="px-4 py-3 text-xs text-slate-400">{l.metadata && Object.keys(l.metadata).length ? JSON.stringify(l.metadata) : "—"}</td>
                  <td className="px-4 py-3 text-slate-500">{fmtDateTime(l.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
